// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3CFNe","insightsList":"newBusinessInsightsMenu_insightsList__131OM","active":"newBusinessInsightsMenu_active__2htve"};